import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Button, Seo } from "@/components";
import { Container } from "@/layouts";
import { ROUTES, useLocalePath } from "@/navigations";

import styles from "./styles.module.css";

const NotFoundPage = memo(() => {
  const { t } = useTranslation("components");
  const { t: tSeo } = useTranslation("Seo");
  const lp = useLocalePath();

  return (
    <section className={styles.wrap}>
      <Seo title={tSeo("notFound.title")} description={tSeo("notFound.description")} path={ROUTES.NOT_FOUND} noindex />
      <Container size="narrow" className={styles.inner}>
        <span className={styles.code}>404</span>
        <h1 className={styles.title}>{tSeo("notFound.title")}</h1>
        <p className={styles.body}>{tSeo("notFound.description")}</p>
        <Button to={lp(ROUTES.HOME)} variant="primary">
          {t("common.backToHome")}
        </Button>
      </Container>
    </section>
  );
});

NotFoundPage.displayName = "NotFoundPage";
export default NotFoundPage;
